import { useQuery } from "react-query";
import { fetchClientType } from "@/features/clientType/services/clientTypeService";
const useClientType = () => {
    // Instead of Promise<ClientType[]>, use ClientType[]
    const { data, error, isLoading, refetch } = useQuery("clientTypes", () => fetchClientType(), {
        staleTime: 60000,
        keepPreviousData: true,
    });
    return {
        // data is ClientType[] | undefined, so default to []
        clientTypes: data ?? [],
        loading: isLoading,
        error: error ? error.message : null,
        refetchClientTypes: refetch,
    };
};
export default useClientType;
